/* merchant/types */
import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, t.null, typeThing]);
}

const tId = t.union([t.undefined, t.string]);

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);

const AdditionalDataCodec = t.type({
  Tag: tOptional(t.string),
  Value: tOptional(t.string),
  Encrypted: t.boolean,
});

const ProcMerchantCodec = t.intersection([
  t.type({
    // ProcessorName: t.unknown,
  }),
  t.partial({
    ProcessorName: t.string,
    MID: t.string,
    AdditionalData: t.array(AdditionalDataCodec),
  }),
]);

const SurchargePercentageCodec = t.intersection([
  t.type({
    CardType: t.string,
  }),
  t.partial({
    Percentage: t.number,
  }),
]);

const ScheduleJobCodec = t.intersection([
  t.type({
    cron: t.string,
    jobType: t.string,
    enabled: t.boolean,
    parameters: t.type({
      MID: t.string,
    }),
    status: t.string,
    timezone: t.string,
  }),
  t.partial({
    lastCompleted: t.string,
    lastExecution: t.string,
    timeSchedule: t.string,
  }),
]);

export type Processor = t.TypeOf<typeof ProcMerchantCodec>;
export type AdditionalData = t.TypeOf<typeof AdditionalDataCodec>;
export type SurchargePercentage = t.TypeOf<typeof SurchargePercentageCodec>;

const ContactCodec = t.intersection([
  t.type({}),
  t.partial({
    First: t.string,
    Last: t.string,
    Mobile: t.number,
    Phone: t.number,
    email: t.string,
    SortNumber: t.number,
  }),
]);

const AttributeCodec = t.intersection([
  t.type({
  }),
  t.partial({
    Address1: t.string,
    Address2: t.string,
    FeatureCashOut: t.string,
    FeaturePreAuth: t.string,
    FeatureRefund: t.string,
    FeatureMOTO: t.string,
    VisaMCRThreshold: t.number,
    MastercardMCRThreshold: t.number,
    MCC: t.string,
    AutoSoftwareUpdateEnabled: t.string,
    BpCardSupport: t.string,
    CabchargeFastCardEnabled: t.string,
    CloudPOS: t.string,
    CustomerReceiptPrint: t.string,
    FeatureA2BTaxiModeEnabled: t.string,
    FeatureBPGiftCards: t.string,
    FeatureCabchargeFastCardEnabled: t.string,
    FeatureCompletion: t.string,
    FeatureCryptoDotComEnabled: t.string,
    FeatureCryptoDotComRefundsEnabled: t.string,
    FeatureDRCLoyaltyCashPasswordProtect: t.string,
    FeatureDRCLoyaltyEnabled: t.string,
    FeatureFixedAmountEntryEnabled: t.string,
    FeatureLastSettle: t.string,
    FeatureMentorLite: t.string,
    FeaturePartialPaymentEnabled: t.string,
    FeaturePreSettle: t.string,
    FeaturePurWithCash: t.string,
    FeaturePurWithTip: t.string,
    FixedAmountEntryUseUserSupplied: t.string,
    Location: t.string,
    POSApp: t.string,
    Receipt: t.string,
    ReceiptMerchant: t.string,
    Standalone: t.string,
  }),
]);

const TerminalCodec = t.intersection([
    t.type({
        attributes: AttributeCodec
    }),
    t.partial({

    }),
]);

const DataCodec = t.intersection([
  t.type({
    id: tId,
    MID: t.string,
    TID: t.string,
  }),
  t.partial({
    terminal: TerminalCodec,
    createdAt: t.string,
    updatedAt: t.string,
    scheduleJob: ScheduleJobCodec,
  }),
]);

export type Data = t.TypeOf<typeof DataCodec>;
export type Error = t.TypeOf<typeof ErrorCodec>;

const MetaCodec = t.type({
  totalObjects: tOptional(t.number),
});
export type Meta = t.TypeOf<typeof MetaCodec>;

export const MerchantCodec = t.type(
  {
    // errors: tOptional(t.union([t.undefined, t.array(ErrorCodec)])),
    errors: tOptional(t.array(ErrorCodec)),
    data: tOptional(t.array(DataCodec)),
    dataAll: tOptional(t.array(DataCodec)),
    meta: tOptional(MetaCodec),
  },
  "MerchantCodec"
);

export type MerchantStaging = t.TypeOf<typeof MerchantCodec>;

export enum MerchantStagingActionTypes {
  FETCH = "@@merchantStage/FETCH",
  FETCH_ALL = "@@merchantStage/FETCH_ALL",
  FETCH_SUCCESS = "@@merchantStage/FETCH_SUCCESS",
  FETCHALL_SUCCESS = "@@merchantStage/FETCHALL_SUCCESS",
  FETCH_ERROR = "@@merchantStage/FETCH_ERROR",
  SAVE_REQUEST = "@@merchantStage/SAVE_REQUEST",
  SAVE_SUCCESS = "@@merchantStage/SAVE_SUCCESS",
  SAVE_ERROR = "@@merchantStage/SAVE_ERROR",
  DELETE_REQUEST = "@@merchantStage/DELETE_REQUEST",
  DELETE_SUCCESS = "@@merchantStage/DELETE_SUCCESS",
  DELETE_ERROR = "@@merchantStage/DELETE_ERROR",
  UPDATE_STATE = '@@merchantStage/UPDATE_STATE",',
  DOWNLOAD_REQUEST = '@@merchantStage/DOWNLOAD_REQUEST",',
}

export interface MerchantStagingState {
  readonly loading: boolean;
  readonly data: MerchantStaging | undefined;
  readonly dataAll: MerchantStaging | undefined;
  readonly errors?: string;
}
